import { WorkflowSelectV2 } from '@frontend/workflow/select';
import { WorkflowType } from '@frontend/workflow/types';

export interface ColliWorkflowFieldProps {
    onChange: (value: string | null) => void;
    value: string | null;
    disabled?: boolean;
    className?: string;
    label?: React.ReactNode;
    required?: boolean;
    options?: string[];
}

export const ColliWorkflowField = (props: ColliWorkflowFieldProps) => {
    return (
        <WorkflowSelectV2
            {...props}
            queryParams={{ type: WorkflowType.COLLI }}
            isClearable
        />
    );
};
